// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup-form {
  background-color: #f8f8f8;
  border: #000 .2em solid;
  border-radius: 1em;
  box-shadow: .2rem .2rem 1rem .1rem rgba(0, 0, 0, 64);
  display: grid;
  grid-template-columns: auto auto;
  grid-template-rows: auto auto auto auto;
  padding: 1em;
  position: absolute;
  row-gap: .4em;
  z-index: 100;
}

.visibility-hidden {
  visibility: hidden;
}

.required-field-indicator {
  color: #df0024;
}

.popup-form-label {
  align-content: start;
  grid-column: 1;
}

.popup-form-control {
  grid-column: 2;
}

.buttons {
  align-content: end;
  grid-column: 1 / span 2;
}

.name-label {
  grid-row: 1;
}

.email-label {
  grid-row: 2;
}

.message-label {
  grid-row: 3;
}

.name-control {
  grid-row: 1;
}

.email-control {
  grid-row: 2;
}

.message-control {
  grid-row: 3;
}
`, "",{"version":3,"sources":["webpack://./src/popup-form/popup-form.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,oDAAoD;EACpD,aAAa;EACb,gCAAgC;EAChC,uCAAuC;EACvC,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb","sourcesContent":[".popup-form {\n  background-color: #f8f8f8;\n  border: #000 .2em solid;\n  border-radius: 1em;\n  box-shadow: .2rem .2rem 1rem .1rem rgba(0, 0, 0, 64);\n  display: grid;\n  grid-template-columns: auto auto;\n  grid-template-rows: auto auto auto auto;\n  padding: 1em;\n  position: absolute;\n  row-gap: .4em;\n  z-index: 100;\n}\n\n.visibility-hidden {\n  visibility: hidden;\n}\n\n.required-field-indicator {\n  color: #df0024;\n}\n\n.popup-form-label {\n  align-content: start;\n  grid-column: 1;\n}\n\n.popup-form-control {\n  grid-column: 2;\n}\n\n.buttons {\n  align-content: end;\n  grid-column: 1 / span 2;\n}\n\n.name-label {\n  grid-row: 1;\n}\n\n.email-label {\n  grid-row: 2;\n}\n\n.message-label {\n  grid-row: 3;\n}\n\n.name-control {\n  grid-row: 1;\n}\n\n.email-control {\n  grid-row: 2;\n}\n\n.message-control {\n  grid-row: 3;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
